import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled, Typography } from '@mui/material';

import { Worker } from '../../../types/Resource';

const Container = styled('div')`
  height: calc(100% - 48px);
  width: 100%;
`;

const ContainerContent = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

const ContainerCard = styled('div')`
  margin-top: 10px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.2);
  color: ${({ theme }) => theme.color.box_bbg};
  padding: 10px;
`;

const ContentTitle = styled(Typography)`
  color: white;
`;

const Title = styled(Typography)(({ theme }) => ({
  ...theme.externalTypography.body3,
  color: theme.color.secondary.$60,
  height: '16px',
}));

const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.color.box_bbg,
  height: '24px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

const Item = styled('div')`
  margin-top: 8px;
  height: 42px;
`;

const habitLabel = (
  value: null | number | undefined,
  t: (key: string) => string,
) => {
  if (value === 1) return t('slight');
  if (value === 2) return t('severe');
  return t('none');
};

interface HabitViewProps {
  data: Worker | undefined;
}

const HabitView: React.FC<HabitViewProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ContentTitle>{t('project-settingJson.navigator.habit')}</ContentTitle>
      <ContainerContent>
        <ContainerCard>
          <Item>
            <Title>{t('diseases')}</Title>
            <Text>{habitLabel(data?.diseases, t)}</Text>
          </Item>
        </ContainerCard>
        <ContainerCard>
          <Item>
            <Title>{t('smoke')}</Title>
            <Text>{habitLabel(data?.smoke, t)}</Text>
          </Item>
        </ContainerCard>
        <ContainerCard>
          <Item>
            <Title>{t('alcohol')}</Title>
            <Text>{habitLabel(data?.alcohol, t)}</Text>
          </Item>
        </ContainerCard>
      </ContainerContent>
    </Container>
  );
};

export default HabitView;
